import { INewbuildingBrokerCallbackWidget } from 'shared/types/newbuildingBrokerCallbackWidget';
import { actionGenerator } from 'shared/utils/redux';

export enum ENewbuildingBrokerCallbackWidgetActionTypes {
  OpenWidget = 'newbuildingBrokerCallbackWidget/openWidget',
  CloseWidget = 'newbuildingBrokerCallbackWidget/closeWidget',
  SetBookingLoading = 'newbuildingBrokerCallbackWidget/setBookingLoading',
  ToggleBookingExistsModal = 'newbuildingBrokerCallbackWidget/toggleBookingExistsModal',
}

export const openNewbuildingBrokerCallbackWidget = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget,
  INewbuildingBrokerCallbackWidget['offerInfo']
>(ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget);

export const closeNewbuildingBrokerCallbackWidget = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.CloseWidget,
  void
>(ENewbuildingBrokerCallbackWidgetActionTypes.CloseWidget);

export const setNewbuildingBrokerCallbackWidgetBookingLoading = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.SetBookingLoading,
  boolean
>(ENewbuildingBrokerCallbackWidgetActionTypes.SetBookingLoading);

export const toggleNewbuildingBrokerBookingExistsModal = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.ToggleBookingExistsModal,
  boolean
>(ENewbuildingBrokerCallbackWidgetActionTypes.ToggleBookingExistsModal);

export type TNewbuildingBrokerCallbackWidgetActions =
  | ReturnType<typeof openNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof closeNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof setNewbuildingBrokerCallbackWidgetBookingLoading>
  | ReturnType<typeof toggleNewbuildingBrokerBookingExistsModal>;
